export * from './zoomer.component';